import { datadogRum } from '@datadog/browser-rum';

export const showErrorMessage = (errorMessage) => alert(errorMessage);

export const handleErrorResponse = async (response) => {
  handleException({ response }, `${response?.status} Error`);
};

export const handleException = (e, exceptionTitle = 'Error') => {
  const errorData = e.response?.data;
  let errorMessage = e?.toString();
  // Handle Axios error response;
  if (errorData) {
    errorMessage =
      errorData.ErrorMessage ||
      errorData.message ||
      (typeof errorData === 'object'
        ? JSON.stringify(errorData)
        : `${errorData}`);
  }

  showErrorMessage(`${exceptionTitle}: ${errorMessage}`);
  console.error(errorMessage);
  datadogRum.addError(e);
};

export const useBasicExceptionHandler = (action, finalAction) => {
  return async (...params) => {
    let response;

    try {
      response = await action(...params);
    } catch (e) {
      handleException(e);
    }
    await finalAction?.();

    return response;
  };
};
